/**
 * tble-biz.com GA4 · GTM 사용자 행동 측정 스크립트
 */
export function initTbleBizAnalytics() {
  if (typeof window === 'undefined') return;
  if (window.__TBLE_BIZ_ANALYTICS_INITIALIZED__) return;
  window.__TBLE_BIZ_ANALYTICS_INITIALIZED__ = true;

  window.dataLayer = window.dataLayer || [];

  function pushEvent(eventName, params) {
    window.dataLayer.push({
      event: eventName,
      page_path: window.location.pathname,
      ...params,
    });
  }

  const consultCtas = {
    'button-header-cta': 'header',
    'button-promo-cta': 'top_promo',
    'button-solution-cta': 'solution',
    'button-benefits-cta': 'benefits',
    'button-services-cta': 'services',
    'button-business-type-cta': 'business_type',
    'button-proof-cta': 'proof',
    'button-cases-cta': 'proof',
    'button-process-cta': 'process',
    'button-process-page-cta': 'process',
    'button-faq-consult': 'faq',
    'button-faq-page-cta': 'faq',
    'button-final-cta-primary': 'bottom',
    'button-floating-contact': 'floating',
  };

  let lastConsultSource = 'unknown';

  document.addEventListener('click', function (event) {
    const control = event.target.closest('button[data-testid], a[data-testid], a[href^="tel:"], a[href*="pf.kakao.com"]');
    if (!control) return;

    const testId = control.getAttribute('data-testid') || '';
    const ctaText = (control.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 100);
    const href = control.getAttribute('href') || '';

    if (consultCtas[testId]) {
      lastConsultSource = consultCtas[testId];
      window.__TBLE_LAST_CONSULT_CTA__ = {
        cta_location: lastConsultSource,
        cta_id: testId,
        cta_text: ctaText,
      };
      return;
    }

    if (testId === 'button-final-cta-kakao' || testId === 'button-modal-kakao' || href.includes('pf.kakao.com')) {
      pushEvent('contact_kakao', {
        cta_location: testId === 'button-final-cta-kakao' ? 'bottom' : 'modal',
        link_url: href,
      });
      return;
    }

    if (testId === 'button-final-cta-phone' || testId === 'button-modal-phone' || href.startsWith('tel:')) {
      pushEvent('contact_phone', {
        cta_location: testId === 'button-final-cta-phone' ? 'bottom' : 'modal',
        link_url: href,
      });
    }
  });

  // 클릭 횟수가 아니라 실제 문의 모달이 열린 횟수를 기록한다.
  function isConsultModalVisible() {
    const modal = document.querySelector('[data-testid="consult-modal"], [role="dialog"]');
    if (!modal) return false;

    const style = window.getComputedStyle(modal);
    return modal.getClientRects().length > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }

  let wasConsultModalVisible = isConsultModalVisible();

  const modalObserver = new MutationObserver(function () {
    const isVisible = isConsultModalVisible();

    if (isVisible && !wasConsultModalVisible) {
      const source = window.__TBLE_LAST_CONSULT_CTA__ || {
        cta_location: lastConsultSource,
        cta_id: 'unknown',
        cta_text: '',
      };

      pushEvent('consult_modal_open', source);
    }

    wasConsultModalVisible = isVisible;
  });

  modalObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'open', 'aria-hidden'],
  });

  // GA4 기본 scroll은 약 90% 도달 시 한 번만 발생한다.
  // 아래 이벤트는 25/50/75/90% 구간을 별도로 측정한다.
  const sentScrollDepths = new Set();
  const scrollThresholds = [25, 50, 75, 90];

  function trackScrollDepth() {
    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );
    const viewportBottom = window.scrollY + window.innerHeight;
    const scrollableHeight = Math.max(documentHeight - window.innerHeight, 1);
    const percent = Math.min(100, Math.round(((viewportBottom - window.innerHeight) / scrollableHeight) * 100));

    scrollThresholds.forEach(function (threshold) {
      if (percent >= threshold && !sentScrollDepths.has(threshold)) {
        sentScrollDepths.add(threshold);
        pushEvent('scroll_depth', {
          percent_scrolled: threshold,
        });
      }
    });
  }

  window.addEventListener('scroll', trackScrollDepth, { passive: true });
  trackScrollDepth();

  // GA4 기본 참여시간과 별도로 활성 화면 체류 구간을 기록한다.
  const engagementThresholds = [10, 30, 60, 120];
  const sentEngagementMilestones = new Set();
  let visibleSeconds = 0;

  window.setInterval(function () {
    if (document.visibilityState !== 'visible' || !document.hasFocus()) return;

    visibleSeconds += 1;

    engagementThresholds.forEach(function (threshold) {
      if (visibleSeconds >= threshold && !sentEngagementMilestones.has(threshold)) {
        sentEngagementMilestones.add(threshold);
        pushEvent('engagement_milestone', {
          engagement_seconds: threshold,
        });
      }
    });
  }, 1000);

  // 문의 저장 API 성공 콜백에서 호출할 전역 함수.
  // 이름, 전화번호, 이메일, 문의 내용 등 개인정보는 GA로 보내지 않는다.
  window.trackConsultSubmitSuccess = function () {
    pushEvent('generate_lead', {
      form_location: lastConsultSource,
      lead_type: 'free_consultation',
    });
  };
}
